import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  urlBase = environment.urlBase;

  constructor(
    private http: HttpClient,
  ) { }

  //Logeo de usuario
  login(loginForm: any): Observable<any> {
    return this.http.post(`${this.urlBase}auth/loginUser`, loginForm)
  }
  //Verificacion del token de usuario
  verificaAutenticacion(): Observable<any> {
    return this.http.post(`${this.urlBase}auth/checkToken`, null);
  }
  //Recuperación de contraseña
  resetPassword(resetForm: any): Observable<any> {
    return this.http.post(`${this.urlBase}auth/resetPassword`, resetForm)
  }

  updateCredential(resetForm: any): Observable<any> {
    return this.http.post(`${this.urlBase}auth/updateCredential`, resetForm)
  }

  checkUserRole(userId: number): Observable<any> {
    return this.http.post(`${this.urlBase}auth/checkUserRole`, { userId });
  }
}
